import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";
import { useEffect, useRef } from "react";

export const useStickyNoteListHooks = () => {
  const toolTipTheme = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: "rgba(255, 240, 0, 1)",
            color: "black",
            borderRadius: "4px",
            border: "1px solid black",
            margin: 0
          },
          popper: {
            opacity: 0.9
          }
        }
      }
    }
  });

  const dataGridTheme = createTheme({
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: {
            fontFamily: "inherit"
          },
          columnHeader: {
            backgroundColor: "rgba(255, 240, 192, 1)"
          },
          columnHeaderTitle: {
            fontWeight: "700"
          }
        }
      }
    }
  });

  const progressTheme = createTheme({
    components: {
      MuiCircularProgress: {
        styleOverrides: {
          colorPrimary: {
            color: "rgba(235, 220, 0, 1)"
          }
        }
      }
    }
  });

  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    resizeObserverRef.current = new ResizeObserver(() => {
      const conditionSelector = document.querySelector("#conditionSelector");

      if (conditionSelector) {
        const height = conditionSelector.getBoundingClientRect().height;

        document.body.style.setProperty(
          "--condition-selector-height",
          `${height}px`
        );
      }
    });

    resizeObserverRef.current.observe(document.body);

    return () => {
      resizeObserverRef.current?.disconnect();
      resizeObserverRef.current = null;
    };
  }, []);

  return {
    toolTipTheme,
    dataGridTheme,
    progressTheme
  } as const;
};
